<div class="loader" [ngSwitch]="loaderType">
  <div *ngSwitchCase="'file-packing'">
    <app-loader-packing-files></app-loader-packing-files>
  </div>

  <div *ngSwitchCase="'file-loader'">
    <app-loader-files></app-loader-files>
  </div>

  <div *ngSwitchCase="'deleting-file'">
    <app-loader-delete-files></app-loader-delete-files>
  </div>

  <div *ngSwitchDefault>
    <mat-spinner></mat-spinner>
  </div>
</div>
<span class="loader-label">{{ label }}</span>
